(() => {
  const formattedReviewCounts = new WeakMap();
  const formatReviewCounts = (root = document) => {
    root.querySelectorAll('.product-card-wrapper .jdgm-prev-badge__text').forEach((node) => {
      if (formattedReviewCounts.get(node) === node.textContent) return;
      const match = node.textContent.match(/[\d.,]+/);
      if (!match) return;
      const count = Number(match[0].replace(/\D/g, ''));
      if (!Number.isFinite(count)) return;
      node.textContent = `(${count > 99 ? '99+' : count})`;
      node.setAttribute('aria-label', `${count} avaliações`);
      formattedReviewCounts.set(node, node.textContent);
    });
  };

  const boot = () => {
    const params = new URLSearchParams(window.location.search);
    if (document.body.classList.contains('template-search') && params.get('gift_finder') === '1') {
      document.querySelectorAll('input[type="search"][name="q"]').forEach((input) => {
        if (input.value === '-tag:__gift_finder_none__') input.value = '';
      });
    }

    let globalFinderPromise = null;
    document.addEventListener('click', async (event) => {
      // Product pages use the opener's home-page URL instead of loading the finder here.
      if (document.body.classList.contains('template-product')) return;
      const opener = event.target.closest('[data-finder-open]');
      if (!opener || document.querySelector('pra-gift-finder [data-finder-modal]')) return;
      event.preventDefault();
      if (!globalFinderPromise) {
        globalFinderPromise = fetch(`${window.Shopify?.routes?.root || '/'}?gift_finder_source=1`)
          .then((response) => {
            if (!response.ok) throw new Error(`Gift Finder page: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const source = parsed.querySelector('pra-gift-finder');
            const sourceModal = source?.querySelector('[data-finder-modal]');
            if (!source || !sourceModal) throw new Error('Gift Finder modal not found on home page');
            const finder = document.createElement('pra-gift-finder');
            finder.className = 'pra-v2-home pra-v2-global-finder';
            ['filterSourceUrl', 'searchUrl'].forEach((key) => {
              if (source.dataset[key]) finder.dataset[key] = source.dataset[key];
            });
            finder.append(sourceModal.cloneNode(true));
            document.body.append(finder);
            return finder;
          })
          .catch((error) => {
            globalFinderPromise = null;
            console.warn(error);
            window.location.href = opener.href;
            return null;
          });
      }
      const finder = await globalFinderPromise;
      if (!finder) return;
      await customElements.whenDefined('pra-gift-finder');
      finder.lastOpenButton = opener;
      finder.open();
    }, true);

    formatReviewCounts();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('.product-card-wrapper, .jdgm-prev-badge__text')) formatReviewCounts(node.parentElement || node);
        else if (node.querySelector?.('.product-card-wrapper .jdgm-prev-badge__text')) formatReviewCounts(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
